// This file is auto-generated by @hey-api/openapi-ts
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { createSseClient } from "../core/serverSentEvents.gen";
import { getValidRequestBody } from "../core/utils.gen";
import { buildUrl, createConfig, createInterceptors, getParseAs, mergeConfigs, mergeHeaders, setAuthParams, } from "./utils.gen";
export var createClient = function (config) {
    if (config === void 0) { config = {}; }
    var _config = mergeConfigs(createConfig(), config);
    var getConfig = function () { return (__assign({}, _config)); };
    var setConfig = function (config) {
        _config = mergeConfigs(_config, config);
        return getConfig();
    };
    var interceptors = createInterceptors();
    var beforeRequest = function (options) { return __awaiter(void 0, void 0, void 0, function () {
        var opts, url;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    opts = __assign(__assign(__assign({}, _config), options), { fetch: (_b = (_a = options.fetch) !== null && _a !== void 0 ? _a : _config.fetch) !== null && _b !== void 0 ? _b : globalThis.fetch, headers: mergeHeaders(_config.headers, options.headers), serializedBody: undefined });
                    if (!opts.security) return [3 /*break*/, 2];
                    return [4 /*yield*/, setAuthParams(__assign(__assign({}, opts), { security: opts.security }))];
                case 1:
                    _c.sent();
                    _c.label = 2;
                case 2:
                    if (!opts.requestValidator) return [3 /*break*/, 4];
                    return [4 /*yield*/, opts.requestValidator(opts)];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4:
                    if (opts.body !== undefined && opts.bodySerializer) {
                        opts.serializedBody = opts.bodySerializer(opts.body);
                    }
                    // remove Content-Type header if body is empty to avoid sending invalid requests
                    if (opts.body === undefined || opts.serializedBody === "") {
                        opts.headers.delete("Content-Type");
                    }
                    url = buildUrl(opts);
                    return [2 /*return*/, { opts: opts, url: url }];
            }
        });
    }); };
    var request = function (options) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, opts, url, requestInit, request, _b, _c, fn, e_1_1, _fetch, response, _d, _e, fn, e_2_1, result, parseAs, emptyData, _f, data, _g, textError, jsonError, error, finalError, _h, _j, fn, e_3_1;
        var e_1, _k, e_2, _l, e_3, _m;
        var _o;
        return __generator(this, function (_p) {
            switch (_p.label) {
                case 0: return [4 /*yield*/, beforeRequest(options)];
                case 1:
                    _a = _p.sent(), opts = _a.opts, url = _a.url;
                    requestInit = __assign(__assign({ redirect: "follow" }, opts), { body: getValidRequestBody(opts) });
                    request = new Request(url, requestInit);
                    _p.label = 2;
                case 2:
                    _p.trys.push([2, 7, 8, 9]);
                    _b = __values(interceptors.request.fns), _c = _b.next();
                    _p.label = 3;
                case 3:
                    if (!!_c.done) return [3 /*break*/, 6];
                    fn = _c.value;
                    if (!fn) return [3 /*break*/, 5];
                    return [4 /*yield*/, fn(request, opts)];
                case 4:
                    request = _p.sent();
                    _p.label = 5;
                case 5:
                    _c = _b.next();
                    return [3 /*break*/, 3];
                case 6: return [3 /*break*/, 9];
                case 7:
                    e_1_1 = _p.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 9];
                case 8:
                    try {
                        if (_c && !_c.done && (_k = _b.return)) _k.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 9:
                    _fetch = opts.fetch;
                    return [4 /*yield*/, _fetch(request)];
                case 10:
                    response = _p.sent();
                    _p.label = 11;
                case 11:
                    _p.trys.push([11, 16, 17, 18]);
                    _d = __values(interceptors.response.fns), _e = _d.next();
                    _p.label = 12;
                case 12:
                    if (!!_e.done) return [3 /*break*/, 15];
                    fn = _e.value;
                    if (!fn) return [3 /*break*/, 14];
                    return [4 /*yield*/, fn(response, request, opts)];
                case 13:
                    response = _p.sent();
                    _p.label = 14;
                case 14:
                    _e = _d.next();
                    return [3 /*break*/, 12];
                case 15: return [3 /*break*/, 18];
                case 16:
                    e_2_1 = _p.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 18];
                case 17:
                    try {
                        if (_e && !_e.done && (_l = _d.return)) _l.call(_d);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7 /*endfinally*/];
                case 18:
                    result = {
                        request: request,
                        response: response,
                    };
                    if (!response.ok) return [3 /*break*/, 34];
                    parseAs = (_o = (opts.parseAs === "auto"
                        ? getParseAs(response.headers.get("Content-Type"))
                        : opts.parseAs)) !== null && _o !== void 0 ? _o : "json";
                    if (!(response.status === 204 ||
                        response.headers.get("Content-Length") === "0")) return [3 /*break*/, 25];
                    emptyData = void 0;
                    _f = parseAs;
                    switch (_f) {
                        case "arrayBuffer": return [3 /*break*/, 19];
                        case "blob": return [3 /*break*/, 19];
                        case "text": return [3 /*break*/, 19];
                        case "formData": return [3 /*break*/, 21];
                        case "stream": return [3 /*break*/, 22];
                        case "json": return [3 /*break*/, 23];
                    }
                    return [3 /*break*/, 23];
                case 19: return [4 /*yield*/, response[parseAs]()];
                case 20:
                    emptyData = _p.sent();
                    return [3 /*break*/, 24];
                case 21:
                    emptyData = new FormData();
                    return [3 /*break*/, 24];
                case 22:
                    emptyData = response.body;
                    return [3 /*break*/, 24];
                case 23:
                    emptyData = {};
                    return [3 /*break*/, 24];
                case 24: return [2 /*return*/, opts.responseStyle === "data"
                        ? emptyData
                        : __assign({ data: emptyData }, result)];
                case 25:
                    data = void 0;
                    _g = parseAs;
                    switch (_g) {
                        case "arrayBuffer": return [3 /*break*/, 26];
                        case "blob": return [3 /*break*/, 26];
                        case "formData": return [3 /*break*/, 26];
                        case "json": return [3 /*break*/, 26];
                        case "text": return [3 /*break*/, 26];
                        case "stream": return [3 /*break*/, 28];
                    }
                    return [3 /*break*/, 29];
                case 26: return [4 /*yield*/, response[parseAs]()];
                case 27:
                    data = _p.sent();
                    return [3 /*break*/, 29];
                case 28: return [2 /*return*/, opts.responseStyle === "data"
                        ? response.body
                        : __assign({ data: response.body }, result)];
                case 29:
                    if (!(parseAs === "json")) return [3 /*break*/, 33];
                    if (!opts.responseValidator) return [3 /*break*/, 31];
                    return [4 /*yield*/, opts.responseValidator(data)];
                case 30:
                    _p.sent();
                    _p.label = 31;
                case 31:
                    if (!opts.responseTransformer) return [3 /*break*/, 33];
                    return [4 /*yield*/, opts.responseTransformer(data)];
                case 32:
                    data = _p.sent();
                    _p.label = 33;
                case 33: return [2 /*return*/, opts.responseStyle === "data"
                        ? data
                        : __assign({ data: data }, result)];
                case 34: return [4 /*yield*/, response.text()];
                case 35:
                    textError = _p.sent();
                    try {
                        jsonError = JSON.parse(textError);
                    }
                    catch (_q) {
                        // noop
                    }
                    error = jsonError !== null && jsonError !== void 0 ? jsonError : textError;
                    finalError = error;
                    _p.label = 36;
                case 36:
                    _p.trys.push([36, 41, 42, 43]);
                    _h = __values(interceptors.error.fns), _j = _h.next();
                    _p.label = 37;
                case 37:
                    if (!!_j.done) return [3 /*break*/, 40];
                    fn = _j.value;
                    if (!fn) return [3 /*break*/, 39];
                    return [4 /*yield*/, fn(error, response, request, opts)];
                case 38:
                    finalError = (_p.sent());
                    _p.label = 39;
                case 39:
                    _j = _h.next();
                    return [3 /*break*/, 37];
                case 40: return [3 /*break*/, 43];
                case 41:
                    e_3_1 = _p.sent();
                    e_3 = { error: e_3_1 };
                    return [3 /*break*/, 43];
                case 42:
                    try {
                        if (_j && !_j.done && (_m = _h.return)) _m.call(_h);
                    }
                    finally { if (e_3) throw e_3.error; }
                    return [7 /*endfinally*/];
                case 43:
                    finalError = finalError || {};
                    if (opts.throwOnError) {
                        throw finalError;
                    }
                    // TODO: we probably want to return error and improve types
                    return [2 /*return*/, opts.responseStyle === "data"
                            ? undefined
                            : __assign({ error: finalError }, result)];
            }
        });
    }); };
    var makeMethodFn = function (method) { return function (options) {
        return request(__assign(__assign({}, options), { method: method }));
    }; };
    var makeSseFn = function (method) { return function (options) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, opts, url;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, beforeRequest(options)];
                case 1:
                    _a = _b.sent(), opts = _a.opts, url = _a.url;
                    return [2 /*return*/, createSseClient(__assign(__assign({}, opts), { body: opts.body, headers: opts.headers, method: method, onRequest: function (url, init) { return __awaiter(void 0, void 0, void 0, function () {
                                var request, _a, _b, fn, e_4_1;
                                var e_4, _c;
                                return __generator(this, function (_d) {
                                    switch (_d.label) {
                                        case 0:
                                            request = new Request(url, init);
                                            _d.label = 1;
                                        case 1:
                                            _d.trys.push([1, 6, 7, 8]);
                                            _a = __values(interceptors.request.fns), _b = _a.next();
                                            _d.label = 2;
                                        case 2:
                                            if (!!_b.done) return [3 /*break*/, 5];
                                            fn = _b.value;
                                            if (!fn) return [3 /*break*/, 4];
                                            return [4 /*yield*/, fn(request, opts)];
                                        case 3:
                                            request = _d.sent();
                                            _d.label = 4;
                                        case 4:
                                            _b = _a.next();
                                            return [3 /*break*/, 2];
                                        case 5: return [3 /*break*/, 8];
                                        case 6:
                                            e_4_1 = _d.sent();
                                            e_4 = { error: e_4_1 };
                                            return [3 /*break*/, 8];
                                        case 7:
                                            try {
                                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                                            }
                                            finally { if (e_4) throw e_4.error; }
                                            return [7 /*endfinally*/];
                                        case 8: return [2 /*return*/, request];
                                    }
                                });
                            }); }, url: url }))];
            }
        });
    }); }; };
    return {
        buildUrl: buildUrl,
        connect: makeMethodFn("CONNECT"),
        delete: makeMethodFn("DELETE"),
        get: makeMethodFn("GET"),
        getConfig: getConfig,
        head: makeMethodFn("HEAD"),
        interceptors: interceptors,
        options: makeMethodFn("OPTIONS"),
        patch: makeMethodFn("PATCH"),
        post: makeMethodFn("POST"),
        put: makeMethodFn("PUT"),
        request: request,
        setConfig: setConfig,
        sse: {
            connect: makeSseFn("CONNECT"),
            delete: makeSseFn("DELETE"),
            get: makeSseFn("GET"),
            head: makeSseFn("HEAD"),
            options: makeSseFn("OPTIONS"),
            patch: makeSseFn("PATCH"),
            post: makeSseFn("POST"),
            put: makeSseFn("PUT"),
            trace: makeSseFn("TRACE"),
        },
        trace: makeMethodFn("TRACE"),
    };
};
